import _ from "lodash";
import { graphql } from "lib/apolloClient";
import { getStaffListQuery } from "SchoolLibrary/modules/Queries";
import { getStaffListFromCache } from "SchoolLibrary/modules/GraphqlHelpers";
import { getFormattedUserName } from "Utils/GetFormattedUserName";
import { getUserArchivalStatus } from "modules/CommonSelectors";

export const getStaffListEnhancer = graphql(getStaffListQuery, {
  name: "getStaffList",
  options: ({
    organizationId,
    creatorSearchText = "",
    archivalState,
    curriculumProgramIds,
    userArchivedFilters,
    academicYearIds,
  }) => ({
    fetchPolicy: "cache-and-network",
    variables: {
      organizationId,
      searchText: creatorSearchText,
      archivalState,
      curriculumProgramIds,
      userArchivedFilters,
      academicYearIds,
    },
  }),
  skip: ({
    importFromLeLibrary = true,
    skipStaffListQuery,
    curriculumProgramIds,
    isCombinedFiltersEnabled,
    isSchoolOptionsEnabled,
  }) =>
    !importFromLeLibrary ||
    skipStaffListQuery ||
    (isCombinedFiltersEnabled &&
      !isSchoolOptionsEnabled &&
      _.size(curriculumProgramIds) == 0),
  props({
    getStaffList,
    ownProps: {
      organizationId,
      creatorSearchText = "",
      isData,
      isLoading,
      archivalState,
      curriculumProgramIds,
      userArchivedFilters,
      academicYearIds,
    },
  }) {
    const data = getStaffListFromCache({
      organizationId,
      searchText: creatorSearchText,
      archivalState,
      curriculumProgramIds,
      userArchivedFilters,
      academicYearIds,
    });
    const creatorList = _.map(_.get(data, "node.staff.edges"), item => {
      const createdBy = _.get(item, "node");
      const isStaffArchived = getUserArchivalStatus(createdBy);

      return {
        value: createdBy.id,
        label: getFormattedUserName({ user: createdBy }),
        isArchived: isStaffArchived,
      };
    });
    const pageInfo = _.get(data, "node.staff.pageInfo", {});
    const hasNextPage = _.get(pageInfo, "hasNextPage", false);
    const endCursor = _.get(pageInfo, "endCursor", null);
    return {
      isData: isData,
      isLoading: isLoading,
      isCreatorListLoading: _.includes([1, 2], getStaffList["networkStatus"]),
      creatorList,
      options: creatorList,
      hasNextPageForCreatorFilter: hasNextPage,
      isFetchingMoreDataForCreatorFilter: getStaffList.networkStatus === 3,
      loadMoreCreatorFilterFeed: () => {
        getStaffList.fetchMore({
          variables: {
            ...getStaffList.variables,
            after: endCursor,
          },
        });
      },
    };
  },
});
